export const isTouchScreen = (): boolean =>
  'ontouchstart' in window || navigator.maxTouchPoints > 0;
